import { CONTENT_TYPES } from '~/constants';
import { SelectContentModalTypes } from '~/types/content';

import { SelectPostsModal } from './components/SelectPostsModal';
import { SelectReelsModal } from './components/SelectReelsModal';
import { SelectStoriesModal } from './components/SelectStoriesModal';
import { SelectTiktokModal } from './components/SelectTiktokModal';
import { SelectYoutubeModal } from './components/SelectYoutubeModal';

const MODAL_COMPONENTS = {
  [CONTENT_TYPES.post]: SelectPostsModal,
  [CONTENT_TYPES.story]: SelectStoriesModal,
  [CONTENT_TYPES.reels]: SelectReelsModal,
  [CONTENT_TYPES.tiktok]: SelectTiktokModal,
  [CONTENT_TYPES.youtube]: SelectYoutubeModal,
};

interface Props extends SelectContentModalTypes {
  contentType: keyof typeof CONTENT_TYPES;
  titles?: {
    modal?: React.ReactNode;
    selectedPreview?: React.ReactNode;
  };
  creatorId?: string;
}

export const MediaPackDetailSelectContentModal: React.FC<Props> = ({
  contentType,
  disabledItemIds,
  initialSelectedItemIds,
  isOpen,
  maxItems,
  minItems,
  onCancel,
  onClose,
  onSubmit,
  shouldShowSelectionPreview = false,
  titles,
  creatorId,
  ...otherModalComponentProps
}) => {
  const ContentModalComponent = MODAL_COMPONENTS[contentType];

  if (!ContentModalComponent) return null;

  return (
    // @ts-ignore
    <ContentModalComponent
      // typescript v5 update issue
      disabledItemIds={disabledItemIds as any}
      // typescript v5 update issue
      initialSelectedItemIds={initialSelectedItemIds as any}
      isOpen={isOpen}
      maxItems={maxItems}
      minItems={minItems}
      onCancel={onCancel}
      onClose={onClose}
      onSubmit={onSubmit}
      shouldShowSelectionPreview={shouldShowSelectionPreview}
      titles={titles}
      creatorId={creatorId}
      {...otherModalComponentProps}
    />
  );
};
